import { SET_FETCH_ADS, SET_LOADING, SET_ERROR } from "./actionTypes";

const serverUrl = process.env.REACT_APP_SERVER_URL;

export const setAds = (ads) => ({
  type: SET_FETCH_ADS,
  payload: ads,
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const fetchAds = () => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await fetch(`${serverUrl}/ads`);
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const data = await response.json();
      dispatch(setAds(data)); // ✅ Pass data directly (no .ads)
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };
};
